import { useMemo } from "react";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { selectUser } from "../../redux/slices/auth.slice";
import { fetchGroupSummary } from "../../services/groupConsole.service";

export default function useGroupBranchOptions() {
  const user = useSelector(selectUser);
  const groupId = user?.group;

  const summary = useQuery(
    ["group-console-summary", groupId],
    () => fetchGroupSummary(groupId),
    { enabled: !!groupId },
  );

  const options = useMemo(
    () =>
      (summary.data?.branches || []).map((b) => ({
        value: b.school,
        label: b.school_name,
      })),
    [summary.data],
  );

  return { options, isLoading: summary.isLoading };
}
